import * as React from 'react';
import { observer } from 'mobx-react';
import { classNames } from '../../../Shared/utils/classnames';
import tickIcon from '../../assets/svg/icon-tick.svg';
import closeIcon from '../../assets/svg/icon-close.svg';
import { SvgIcon } from '../svg-icon';
import * as styles from './styles.less';

@observer
export class Switch extends React.Component<{
	value: boolean;
	onChangeHandler: (checked: boolean) => void;
	text?: string | JSX.Element;
	disabled?: boolean;
	acceptanceTestTargetId?: string;
	className?: string;
	labelClassName?: string;
}> {
	render() {
		const { value, disabled, acceptanceTestTargetId, className, labelClassName } = this.props;
		return (
			<div className={className}>
				<label
					className={classNames(styles.toggle, labelClassName, {
						[styles.active]: value,
						[styles.disabled]: disabled
					})}
					data-pp-at-target={
						acceptanceTestTargetId
							? `${acceptanceTestTargetId}_label`
							: undefined
					}
				>
					<input
						type="checkbox"
						className={styles.checkbox}
						checked={value}
						disabled={disabled}
						onChange={this.onChangeHandler}
						data-pp-at-target={acceptanceTestTargetId}
					/>
					<span className={styles.toggleBox}>
						<SvgIcon
							className={classNames({
								[styles.activeIcon]: value,
								[styles.inActiveIcon]: !value,
							})}
							scale={value ? 1 : 0.5}
							svg={value ? tickIcon : closeIcon}
						/>
					</span>
				</label>
			</div>
		);
	}

	private onChangeHandler = (ev: React.FormEvent<HTMLInputElement>) => {
		this.props.onChangeHandler(ev.currentTarget.checked);
	};
}
